















































































    import Project from "@/lib/Project";
    import { Prop,Component } from "vue-property-decorator";
    import { mixins } from "vue-class-component";
    import ProjectHelper from "@/mixins/ProjectHelper";
    import Utils from "@/lib/Utils";
import TargetTask from '@/lib/TargetTask';

    @Component
    export default class TaskEditor extends mixins(ProjectHelper){
        task_content = "";
        dueDate = new Date(new Date().getFullYear(), 11, 31);
        visible = false;
        moreVisible = false;
        isEditing = false;        
        projectName = "";
        projectColor = "";
        project!:Project;

        created():void {
            // this.$store.commit("fetchProjectList");
            this.project = this.getProjectById(this.project_id);
            // const task = (this.$store.state.taskList as TargetTask[]).find(i => i.id === this.task_id);
            const task = this.task;
            if(task !== undefined) {
                this.task_content = task.content;
                if(task.dueDate) {
                    this.dueDate = new Date(task.dueDate);
                }
            }
        }

        @Prop({type: String})
        project_id?:string;

        @Prop({type:String})
        task_id?:string;

        @Prop({type: TargetTask})
        task?:TargetTask;
        
        get dueDateString():string {   
            return Utils.formatDate(this.dueDate);
        }

        get addButtonAvaliable():boolean {
            return this.task_content.length <= 0;
        }

        get projectList(): Project[]{
            return (this.$store.state.projectList as Project[]);
        }

        saveTask():void {
            if(this.task_content === "") return;
            if(this.task_id === undefined) {
				console.log("新增任务：",JSON.stringify(this.project));
                const task = new TargetTask();
                task.content = this.task_content;
                task.targetId = this.project.id;
                task.dueDate = this.dueDate===null?null:Utils.formatLocalDate(this.dueDate);
                // task.tags.push(this.selectedTagName);
                this.$store.commit('addTask', task);
            } else {
                const task = (this.$store.state.targetTaskList as TargetTask[]).find(i => i.id === this.task_id);
                if(task) {
                    task.content = this.task_content;
                    task.targetId = this.project.id;
                    task.dueDate = this.dueDate===null?null:Utils.formatLocalDate(this.dueDate);
                    this.$store.commit('updateTask', task);
                }
            }
            
            // 完成后不显示任务编辑
            this.isEditing = false;
            this.task_content = "";
            this.dueDate = new Date(new Date().getFullYear(), 11, 31);;
            this.$emit("finish");
        }

        selectProject(id: string | undefined):void {
            this.project = this.getProjectById(id);
            this.moreVisible = false;
            
        }


        deleteTask(taskId:string):void {
            this.$store.commit("deleteTask",taskId);
            this.$message({
                 message: '删除成功',
                 type: 'info',
                 showClose: true,
            });
        }

       cancel():void {        
           // 清空数据
        this.task_content = "";
        this.dueDate = new Date();
        this.project = this.getProjectById(this.project_id);
        this.$emit("cancel");
       }

    }
